<a
  class="cc-icon cc-icon-close close-modal sm-text-default-text hover:sm-text-default-text hover:sm-no-underline"
  aria-label="Close"
  (click)="onCloseModal()"
></a>

<!-- New link definition form -->
<div class="loaded-container w-100" *ngIf="currentStatus === linkCreateStatus.Initial">
  <header>
    <h1 class="h1">{{ title }}</h1>
    <label class="default-label d-block link-name-label" for="link-name" i18n
      >Give your link a name, select which templates to include, and generate the link</label
    >
    <div class="d-flex align-items-center">
      <input
        [(ngModel)]="taskDefinition.name"
        (input)="onContentValidityChange()"
        placeholder="Link name"
        class="mb-20 form-control link-name-input"
        [class.input-error-state]="!validName"
        type="text"
        ccFocus
      />
      <div *ngIf="!validName" class="mb-4 ml-2 sm-text-default-red">Required</div>
    </div>
  </header>
  <cc-templates-selector
    [isLibrarySelection]="false"
    [templates]="templates"
    [companyTemplateTabs]="company?.templateTags"
    [loading]="isLoading"
    [isDefaultTextColor]="isDefaultTextColor"
    (isAnyTemplateSelected)="onContentValidityChange()"
    [viewType]="templateSelectorViewTypes.Register"
  >
  </cc-templates-selector>
  <footer class="text-left d-flex justify-content-center">
    <button
      type="button"
      (click)="onGenerateLink()"
      class="px-5 btn cc-btn-primary-constructive"
      data-test="generate-link-button"
      i18n
    >
      <span>
        Generate Link
        <ng-container *ngIf="isValid">
          for {{ selectedTemplates.length }} Template{{ selectedTemplates.length > 1 ? 's' : '' }}
        </ng-container>
      </span>
    </button>
  </footer>
</div>

<!-- Loading state while generating the link -->
<div class="link-status-generating-link w-100" *ngIf="currentStatus === linkCreateStatus.GeneratingLink">
  <header>
    <h1 class="h1">{{ title }}</h1>
  </header>
  <section class="text-center">
    <div class="loading-spinner">
      <i class="mr-2 cc-icon cc-icon-spinner-lg"></i><span i18n>Generating code...</span>
    </div>
  </section>
</div>

<!-- Error state -->
<div class="link-status-error w-100" *ngIf="currentStatus === linkCreateStatus.ErrorGeneratingLink">
  <header>
    <h1 class="h1">{{ title }}</h1>
  </header>
  <section class="text-center">
    <i class="cc-icon cc-icon-warning"></i>
    <p class="default-paragraph" i18n>An error has occurred</p>
    <button class="mt-1 btn cc-btn-subtle-blue-helper" (click)="onReset()">Try again</button>
  </section>
</div>
